import {$, datetime, Schema} from 'simpli-web-sdk'
import DeliveryAlertHistoryResponse from '@/model/response/DeliveryAlertHistoryResponse'

export default (model: DeliveryAlertHistoryResponse): Schema => ({
  mensagem: {
    content: model.mensagem,
  },

  documento: {
    content: model.documento,
  },

  motorista: {
    content: model.motorista && model.motorista.nome,
  },

  data: {
    content: datetime(model.data),
  },
})
